import { render, staticRenderFns } from "./Personalize.vue?vue&type=template&id=1932c5fc&lang=pug"
import script from "./Personalize.vue?vue&type=script&lang=ts"
export * from "./Personalize.vue?vue&type=script&lang=ts"
import style0 from "./Personalize.vue?vue&type=style&index=0&id=1932c5fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports